/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_Link_CopiedInputs */

const es_chat_share_modal_link_copied = /** @type {(inputs: Chat_Share_Modal_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado!`)
};

const en_chat_share_modal_link_copied = /** @type {(inputs: Chat_Share_Modal_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Chat_Share_Modal_Link_CopiedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_link_copied = /** @type {((inputs?: Chat_Share_Modal_Link_CopiedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_Link_CopiedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_link_copied(inputs)
	return en_chat_share_modal_link_copied(inputs)
});
export { chat_share_modal_link_copied as "chat.share_modal.link_copied" }